import Vue from 'vue/dist/vue.esm.js'
Vue.component('procurement-changes-modal',
  template: JST['procurement_changes_modal']()
  props: ['ppSet']
  data: ->
    projectPartners: @ppSet
  computed:
    canSubmit: ->
      !@projectPartners.some((pp) -> pp.has_changes == null)
  methods:
    submitForm: (e) ->
      e.preventDefault()
      $.ajax
        url: @submit_url
        method: 'POST'
        data:
          correction_request_row:
            report_document_id: @document_id
            problem: @problem
          authenticity_token: @authenticity_token
        success: =>
          @closeModal()
          @$emit('state-locked')
        error: (response) =>
          error = response.responseJSON[0]
          @errors.problem = error
          @hasErrors = true

    closeModal: ->
      @$emit('close-modal')
)
